import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'trademark', 'Trademark', [["path",{"d":"M4.5 9h5m-2.5 0v6","key":"svg-0"}],["path",{"d":"M13 15v-6l3 4l3 -4v6","key":"svg-1"}]]);